module.exports = __webpack_public_path__ + "img/is_over.6941580a.png";